function getSellingPlanByQty(qty) {
  if (qty <= 2) return '2616230082'; // Monthly
  return null; // qty >= 3 → do not change plan
}

function updateSellingPlan(quantityBox) {
  const input = quantityBox.querySelector('.xo-quantity__number');
  if (!input) return;

  const xoProduct = quantityBox.closest('xo-product');
  if (!xoProduct) return;

  const line = xoProduct.getAttribute('xo-line');
  if (!line) return;

  const qty = parseInt(input.value, 10);
  if (!qty) return;

  const sellingPlanId = getSellingPlanByQty(qty);

  // Prepare payload
  const payload = {
    line: line,
    quantity: qty
  };

  // Only include selling_plan if we have one
  if (sellingPlanId) {
    payload.selling_plan = sellingPlanId;
  }

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  }).then(() => {
    console.log('Plan updated → qty', qty, sellingPlanId ? `(plan set)` : `(default plan)`);
  });
}

// Plus / minus
document.addEventListener('click', function (e) {
  const isPlus  = e.target.closest('xo-cart-quantity-plus');
  const isMinus = e.target.closest('xo-cart-quantity-minus');
  if (!isPlus && !isMinus) return;

  const quantityBox = e.target.closest('xo-cart-quantity');
  if (!quantityBox) return;

  setTimeout(() => updateSellingPlan(quantityBox), 150);
});

// Manual input
let qtyTimer;
document.addEventListener('input', function (e) {
  if (!e.target.matches('.xo-quantity__number')) return;

  const quantityBox = e.target.closest('xo-cart-quantity');
  if (!quantityBox) return;

  clearTimeout(qtyTimer);
  qtyTimer = setTimeout(() => updateSellingPlan(quantityBox), 400);
});
